import { cn } from '../../utils/cn';
import { Icon } from './Icon';

/**
 * ActionIconButton — tablo satır aksiyonları için ikon butonu.
 *
 * zuzzuu_customers `GridRowActions` ile birebir hizalı:
 *   - `size-fit rounded-lg border border-[#E8E8E8] p-1.5`
 *   - 1 px softspecific shadow: `0 1px 1px 0 rgba(0,0,0,0.06)`
 *   - İkon `size-5` (20 px), `iconColor` ile renk taşınır
 *     (edit #3CBFFF, delete #FD5995, active/inactive #513CFF, refresh #00C48C)
 *
 * Kullanım:
 *   <ActionIconButton icon="edit" iconColor="#3CBFFF" title="Düzenle" onClick={...} />
 *   <ActionIconButton icon={<CustomSvg />} iconColor="#FD5995" />
 */
export default function ActionIconButton({
  icon,
  iconColor,
  title,
  onClick,
  disabled = false,
  className,
  ...rest
}) {
  const iconEl =
    typeof icon === 'string' ? (
      <Icon name={icon} className="h-5 w-5" strokeWidth={2} />
    ) : (
      icon
    );

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
      className={cn(
        // customers: size-fit + p-1.5 (6 px) + rounded-lg + #E8E8E8 border
        // + shadow-[0_1px_1px_0_rgba(0,0,0,0.06)]
        'inline-flex items-center justify-center rounded-lg border border-[#E8E8E8] bg-white p-1.5',
        'shadow-[0_1px_1px_0_rgba(0,0,0,0.06)] transition-all duration-150',
        'hover:bg-[#F6F6F6] active:scale-[0.96]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      )}
      style={iconColor ? { color: iconColor } : undefined}
      {...rest}
    >
      {iconEl}
    </button>
  );
}
